import { useGlobalContext } from '@/libs/context/GlobalContext';
import styles from '../blog.module.css';
import { BlogDetailPagination } from './BlogDetailPaginaion';
import { IBlogDetail } from '@/interfaces/IBlogData';
import Image from 'next/image';
type props = {
    blogDetail: IBlogDetail
}
export function BlogDetail({ blogDetail }: props) {
    const { props: { siteUrl } } = useGlobalContext()
    return <section className={styles.my_blog}>
        <div className="container">
            <div className={styles.flex_items}>
                <div className={styles.breadcrumbs}>
                    <ul>
                        <li><a href={`${siteUrl}/blogs`}>Blogs</a></li>
                        <li>{blogDetail.title}</li>
                    </ul>
                </div>
            </div>

            <div id="all-blog-post">
                <div className="mb10"><h2 className="font30 fontsm18 fontMedium text333">{blogDetail.title}</h2></div>
                <div className={`${styles.blog_grid} ${styles.blog_detail}`}>
                    <div className={`${styles.blog_box} ${styles.shadownone}`}>
                        <div className={styles.blog_img}>
                            <Image src={blogDetail.post_images || "/assets/images/blog-detail-banner.jpg"} width={1240} height={507} alt="blog" />
                            <div className={styles.sharing_media}>
                                <ul>
                                    <li>
                                        {/* <a className={styles.share}><span className={styles.icons}><Image src="/assets/images/share-icon.svg" width={15} height={17} alt="share" /></span></a> */}
                                        <div className={styles.social_media}>
                                            <ul className={styles.social_icons}>
                                                {/* <li><a href="" className={styles.facebook}><span><Image src="/assets/images/facebook.svg" height={21} width={21} alt="facebook" /></span>Facebook</a></li>
                                                <li><a href="" className={styles.linkedin}><span><Image src="/assets/images/linkedin.svg" height={21} width={21} alt="Linkedin" /></span>Linkedin</a></li>
                                                <li><a href="" className={styles.instagram}><span><Image src="/assets/images/instagram.svg" height={21} width={21} alt="instagram" /></span>Insatagram</a></li>
                                                <li><a href="" className={styles.whatsapp}><span><Image src="/assets/images/whatsapp.svg" height={21} width={21} alt="Whatsapp" /></span>Whatsapp</a></li> */}
                                            </ul>
                                        </div>
                                    </li>
                                    {/* <li><a href=""><Image src="/assets/images/like-icon.svg" width={15} height={13} alt="like-icon" /></a></li> */}
                                </ul>
                            </div>
                        </div>
                        <div className={`${styles.blog_content} ${styles.pl_0}`}>
                            <div className={styles.blog_user_profile}>
                                <div className={styles.profile_col}>
                                    <span className={styles.img_cirlcle}>
                                        <img src="/assets/images/blogger.png" alt="" />
                                    </span>
                                    <div className={`${styles.text_col}`}>
                                        <span className={styles.date}>{blogDetail.publish_date}</span>
                                    </div>
                                </div>
                                <div className={styles.review}>
                                    <ul>
                                        {/* <li><span><Image src="/assets/images/review-icon.svg" width={16} height={9} alt="view" /></span> 500K</li>
                                        <li><span><Image src="/assets/images/like-icon.svg" alt="view" width={16} height={14} /></span>500</li> */}

                                    </ul>
                                </div>
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: blogDetail.content }} />

                            {blogDetail.faq.length > 0 && <div className={styles.fask_quetions}>
                                <h4>Frequently Asked Questions</h4>
                                <ul>
                                    {blogDetail && blogDetail?.faq.map((f, idx) =>
                                        <li key={idx}><strong>{f.question}</strong>
                                            <p>{f.answer}</p>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            }
                            <div className={styles.grid_media}>
                                <div className={styles.social_media_icon}>
                                    <ul>
                                        {/* <li><a href="" className={styles.facebook}><span><Image src="/assets/images/facebook.svg" width={21} height={21} alt="facebook" /></span></a></li>
                                        <li><a href="" className={styles.linkedin}><span><Image src="/assets/images/linkedin.svg" width={21} height={21} alt="Linkedin" /></span></a></li>
                                        <li><a href="" className={styles.instagram}><span><Image src="/assets/images/instagram.svg" width={21} height={21} alt="instagram" /></span></a></li>
                                        <li><a href="" className={styles.whatsapp}><span><Image src="/assets/images/whatsapp.svg" width={21} height={21} alt="Whatsapp" /></span></a></li> */}
                                    </ul>
                                </div>

                                <div className={styles.Bio_text}>
                                    <h4>{blogDetail.post_author}</h4>
                                    <span className={styles.bio}>Author</span>
                                    <span className={styles.bio_words}>{blogDetail.author_details}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <BlogDetailPagination /> */}
        </div>
    </section>

}